import AdminSections from './AdminSections';
import ValidatedForm from '../forms/ValidatedForm';
import FieldLabel, { RequiredFieldsNote } from '../forms/FieldLabel';
import AdminPublishBar from "./AdminPublishBar";

export default function AboutEditor({ content, storyDraft, saving, dirty, onChange, onDiscard, onStoryChange, onStatChange, onSubmit }) {
  return (
    <ValidatedForm className="admin-editor" onSubmit={onSubmit}>
      <div className="admin-editor-heading">
        <div>
          <p className="admin-kicker">Page content</p>
          <h2>About page</h2>
          <p>Changes remain private until you publish them.</p>
        </div>
        <a href="/about" target="_blank" rel="noopener noreferrer">View page</a>
      </div>
      <RequiredFieldsNote />
      <AdminSections label="About page sections">
      <fieldset className="admin-form-section" data-section-label="Introduction">
        <legend>Introduction</legend>
        <FieldLabel>Kicker<input value={content.kicker} onChange={(event) => onChange("kicker", event.target.value)} required /></FieldLabel>
        <FieldLabel>Page title<input value={content.title} onChange={(event) => onChange("title", event.target.value)} required /></FieldLabel>
        <FieldLabel>Introduction<textarea rows="7" value={content.intro} onChange={(event) => onChange("intro", event.target.value)} required /></FieldLabel>
      </fieldset>
      <fieldset className="admin-form-section" data-section-label="Highlights">
        <legend>Highlights</legend>
        <div className="admin-stat-grid">
          {content.stats.map((stat, index) => (
            <fieldset key={index}>
              <legend>Highlight {index + 1}</legend>
              <FieldLabel>Value<input value={stat.value} onChange={(event) => onStatChange(index, "value", event.target.value)} required /></FieldLabel>
              <FieldLabel>Label<input value={stat.label} onChange={(event) => onStatChange(index, "label", event.target.value)} required /></FieldLabel>
            </fieldset>
          ))}
        </div>
      </fieldset>
      <fieldset className="admin-form-section" data-section-label="Story">
        <legend>Story</legend>
        <FieldLabel>Story heading<input value={content.storyTitle} onChange={(event) => onChange("storyTitle", event.target.value)} required /></FieldLabel>
        <FieldLabel>Story paragraphs <small>Separate paragraphs with a blank line.</small><textarea rows="10" value={storyDraft} onChange={(event) => onStoryChange(event.target.value)} required /></FieldLabel>
      </fieldset>
      <fieldset className="admin-form-section" data-section-label="Image">
        <legend>Image</legend>
        <FieldLabel>Image URL<input type="url" value={content.imageUrl} onChange={(event) => onChange("imageUrl", event.target.value)} required /></FieldLabel>
        <FieldLabel>Image description<input value={content.imageAlt} onChange={(event) => onChange("imageAlt", event.target.value)} required /></FieldLabel>
      </fieldset>
      </AdminSections>
      <AdminPublishBar dirty={dirty} saving={saving} label="Publish About page" onDiscard={onDiscard} />
    </ValidatedForm>
  );
}
